import { Button } from '../../atoms/Button';

function ErrorPage() {
  const refresh = () => {
    window.location.reload();
  };

  const goToMyArea = () => {
    window.location.pathname = '/';
  };

  return (
    <main className="h-screen bg-mono-100 p-2">
      <div
        className="m-auto mt-12 flex w-fit flex-col gap-8 rounded-[16px] bg-white p-2 py-8 shadow-level-1 md:p-8">
        <h4 className="px-2 text-center font-poppins text-base font-bold">
          Ops! Algo inesperado aconteceu.
        </h4>
        <p className="px-2 text-center">
          Mas tá tudo bem! Clique em uma das opções abaixo para voltar para a
          plataforma.
        </p>
        <div className="flex justify-center gap-10">
          <Button variant="outlined" onClick={refresh}>
            Voltar para a página
          </Button>
          <Button variant="outlined" onClick={goToMyArea}>
              Ir para Minha Área
          </Button>
        </div>
      </div>
    </main>
  );
}

export default ErrorPage;
